import PubSub from 'pubsub-js';
import { Constructor } from './contructor.type';
import { BaseFormatEvent } from './base-format-event.model';

class EventBus {
  constructor() {}

  public publish<TEvent extends BaseFormatEvent>(event: TEvent) {
    PubSub.publishSync(event.name, event);
  }

  public subscribe<TEvent extends BaseFormatEvent>(
    constructor: Constructor<TEvent>,
    handler: (event: TEvent) => void
  ) {
    const name = new constructor().name;
    return PubSub.subscribe(name, (_, data) => handler(data as TEvent));
  }

  public unsubscribe(token: string) {
    PubSub.unsubscribe(token);
  }
}

export default new EventBus();
